import React from 'react';

interface TopicChipProps {
  topic: string;
  sentiment?: number; // -1 to 1
  count?: number;
  onClick?: () => void;
  className?: string;
}

const TopicChip: React.FC<TopicChipProps> = ({
  topic,
  sentiment,
  count,
  onClick,
  className = '',
}) => {
  const getStyles = () => {
    if (sentiment === undefined) {
      return 'bg-gray-100 text-gray-800 border-gray-200';
    }

    if (sentiment > 0.3) {
      return 'bg-green-100 text-green-800 border-green-200';
    } else if (sentiment < -0.3) {
      return 'bg-red-100 text-red-800 border-red-200';
    } else {
      return 'bg-yellow-100 text-yellow-800 border-yellow-200';
    }
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={!onClick}
      className={`inline-flex items-center space-x-2 px-3 py-1.5 rounded-full text-sm font-['Open_Sans'] border ${getStyles()} ${
        onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : 'cursor-default'
      } ${className}`}
    >
      <span>{topic}</span>
      {count !== undefined && (
        <span className="text-xs font-semibold bg-white bg-opacity-50 px-1.5 py-0.5 rounded-full">
          {count}
        </span>
      )}
    </button>
  );
};

export default TopicChip;
